import styled from '@emotion/styled';

export default styled.div({
    display: 'flex',
    padding: '0.1rem 1rem 0.1rem 0',
    gap: '1rem',
    alignItems: 'center',
    justifyContent: 'center'
});
